import { api } from "./authService";

// IMPORTANT: api.baseURL already contains '/api' — never prefix with '/api' here.
const BASE = "/visibility-settings";

// Management (ADMIN / BERUFSBILDNER)
async function getAll() {
  const res = await api.get(BASE);
  return res.data;
}

async function getGroup(professionType, targetRole) {
  const res = await api.get(`${BASE}/${professionType}/${targetRole}`);
  return res.data;
}

async function updateGroup(professionType, targetRole, settings) {
  const res = await api.put(`${BASE}/${professionType}/${targetRole}`, {
    settings,
  });
  return res.data;
}

// Current user's effective visibility map
async function getMyVisibility() {
  const res = await api.get(`${BASE}/me`);
  return res.data;
}

const visibilityService = {
  getAll,
  getGroup,
  updateGroup,
  getMyVisibility,
};

export default visibilityService;
